import { Form, InfoContacto } from "./components";

export default function Contacto() {
  return (
    <div className="container px-4 sm:px-6 md:px-8 py-25">
      <h4 className="title-bordered mt-3">Pide tus cotizaciones...</h4>
      <div className="w-full flex flex-col md:grid md:grid-rows-1 md:grid-cols-2 gap-8 md:gap-16 box-border">
        <Form />
        <InfoContacto/>
      </div>
    </div>
  );
}
